import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { getTextShapeDialogState, State } from "../reducers";
import { updateTextShape, UpdateTextShapeAction } from "./slides";


export interface ShowTextShapeDialogAction {
    readonly type: 'SHOW_TEXT_SHAPE_DIALOG',
    readonly slideUuid: string,
    readonly shapeUuid: string,
    readonly text: string,
}

export interface CloseTextShapeDialogAction {
    readonly type: 'CLOSE_TEXT_SHAPE_DIALOG',
}

export interface TextShapeDialogTextChangedAction {
    readonly type: 'TEXT_SHAPE_DIALOG_TEXT_CHANGED',
    readonly text: string,
}


export function showTextShapeDialog(slideUuid: string, shapeUuid: string, text: string): ShowTextShapeDialogAction {
    return {
        type: 'SHOW_TEXT_SHAPE_DIALOG',
        slideUuid,
        shapeUuid,
        text,
    }
}

export function closeTextShapeDialog(): CloseTextShapeDialogAction {
    return {
        type: 'CLOSE_TEXT_SHAPE_DIALOG',
    }
}

export function submitTextShapeDialog(): ThunkAction<any, State, any, CloseTextShapeDialogAction | UpdateTextShapeAction> {
    return async (dispatch: ThunkDispatch<State, any, CloseTextShapeDialogAction | UpdateTextShapeAction>, getState: () => State): Promise<any> => {
        const state = getState();
        const { slideUuid, shapeUuid, text } = getTextShapeDialogState(state);
        dispatch(updateTextShape(slideUuid, shapeUuid, text));
        dispatch(closeTextShapeDialog());
    };
}

export function textShapeDialogTextChanged(text: string): TextShapeDialogTextChangedAction {
    return {
        type: 'TEXT_SHAPE_DIALOG_TEXT_CHANGED',
        text,
    }
}



// WEBPACK FOOTER //
// ./src/actions/text-shape-dialog.ts